import React from 'react';

import { useScreenMessage } from '@gogame/screens';
import { Typography } from '@gogame/components';
import { getLinkComponent } from '../NotificationsList';

export const useShowNewNotification = () => {
  const { showMessage } = useScreenMessage();

  return ({ onReadMessage, message }) => {
    const NotificationLink = getLinkComponent(message.feature);

    if (NotificationLink) {
      const relatedActionId = Number(message?.relatedActionId);

      showMessage(
        <NotificationLink
          relatedActionId={relatedActionId}
          type={message?.type}
          onClick={() => onReadMessage(relatedActionId)}
        >
          <Typography>{message?.message}</Typography>
        </NotificationLink>,
        {
          ttl: 10000,
          closable: true,
        }
      );
    }
  };
};
